import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { setIsRoomHost, setRoomId } from "../store/actions";
import JoinRoomTitle from "./JoinRoomTitle";
import JoinRoomContent from "./JoinRoomContent";

import "./JoinRoomPage.css";

const JoinRoomPage = (props) => {
  const { setIsRoomHostAction, isRoomHost } = props;
  const { setRoomId, roomId } = props;

  const search = useLocation().search;

  useEffect(() => {
    try {
      const isRoomHost = new URLSearchParams(search).get("host");
      const roomId = new URLSearchParams(search).get("id");
      const usertoken = new URLSearchParams(search).get("user");
      const accessToken = new URLSearchParams(search).get("token");
      const uhid = new URLSearchParams(search).get("uhid");

      const userRoomId = roomId;// localStorage.getItem("roomId");

      if (accessToken) {
        localStorage.setItem('access_token', accessToken); // ✅ Save token locally
      }
      if (uhid) {
        localStorage.setItem('uhid', uhid); // ✅ Save token locally
      }

      const effectiveRoomId = roomId || userRoomId;

      if (usertoken && effectiveRoomId && isRoomHost === "true") {
        setIsRoomHostAction(true);
        setRoomId(effectiveRoomId);
      }
      else if (effectiveRoomId) {
        setRoomId(effectiveRoomId);
      }
      else if (isRoomHost === "true") {
        setIsRoomHostAction(true);
        // const meetingLink = `${window.location.origin}/join-room?id=${roomId}`;
        // console.log("Generated Meeting Link:", meetingLink);
      }

    } catch (error) {
      console.error("Error parsing search parameters or dispatching actions:", error);
    }
  }, [search, setIsRoomHostAction, setRoomId]);

  return (
    <div className="join_room_page_container">
      <div className="join_room_page_panel">
        <JoinRoomTitle isRoomHost={isRoomHost} />
        <JoinRoomContent roomId={roomId} />
      </div>
    </div>
  );
};

const mapStoreStateToProps = (state) => {
  return {
    ...state,
  };
};

const mapActionsToProps = (dispatch) => {
  return {
    setIsRoomHostAction: (isRoomHost) => dispatch(setIsRoomHost(isRoomHost)),
    setRoomId: (roomId) => dispatch(setRoomId(roomId)),
  };
};

export default connect(mapStoreStateToProps, mapActionsToProps)(JoinRoomPage);
